import axios from 'lib/axios'

type IData = {
  name: string
  typeCompanyId: number
  contactName: string
  contactEmail: string
  phone: string
  operativeId: number
  logo?: Blob | null
  hasIntegration: string
  integrationType?: number
  commercialInCharge: string
  companyCategory: number
  workModel: string
  industryType: string
  marketComplexity: string
  lifeCycle: string
  maturityLevel: string
  usesAi: boolean
  hasQuestionnaireManagement: string
}

/**
 * @description service to create a new company
 */
const createNewCompany = async (data: IData) => {
  const body = new FormData()
  body.append('name', data.name)
  body.append('type_company_id', data.typeCompanyId.toString())
  body.append('contact_name', data.contactName)
  body.append('contact_email', data.contactEmail)
  body.append('phone', data.phone)
  body.append('operative_id', data.operativeId.toString())
  body.append('has_integration', data.hasIntegration)
  body.append('commercial_name', data.commercialInCharge)
  body.append('category_id', data.companyCategory.toString())
  body.append('work_model', data.workModel)
  body.append('industry_type_id', data.industryType)
  body.append('market_complexity_id', data.marketComplexity)
  body.append('life_cycle_id', data.lifeCycle)
  body.append('hr_maturity_level_id', data.maturityLevel)
  body.append('uses_ai', data.usesAi.toString())
  body.append(
    'has_questionnaire_management',
    data.hasQuestionnaireManagement,
  )

  if (data.hasIntegration && data.integrationType) {
    body.append('integration_type', data.integrationType.toString())
  }

  if (data.logo) {
    body.append('logo', data.logo, 'logo.png')
  }

  const response = await axios
    .post(`/company`, body, {
      headers: {
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      return res.data
    })
    .catch((error) => {
      return { ok: false, message: error.message }
    })

  return response
}

export default createNewCompany
